<template>
  <el-drawer v-model="drawer" title="基础信息" size="40%" :direction="direction" :before-close="handleClose">
    <el-form v-if="detail" ref="editShopForm" :inline="true"  :model="detail" label-width="100px">
      <form-item-rule  label="门店名称" prop="storeName">
        <el-input placeholder="请输入门店名称" class="w300" v-model="detail.storeName"></el-input>
      </form-item-rule>
      <form-item-rule   label="门店照片" prop="logo">
        <upload :type="1" :width="200"  v-model="detail.logo"></upload>
      </form-item-rule>
      <form-item-rule  label="门店定位" prop="longitude">
        <tx-map @change="changeAddress" :lat="detail.latitude" :lng="detail.longitude" :address-text="detail.address"></tx-map>
      </form-item-rule>
      <form-item-rule  label="门店地址" prop="address">
        <el-input placeholder="请输入门店地址" class="w500" type="textarea" :rows="4" v-model="detail.address"></el-input>
      </form-item-rule>
      <form-item-rule  label="联系电话" prop="storePhone">
        <el-input placeholder="请输入联系电话" class="w300" v-model="detail.storePhone"></el-input>
      </form-item-rule>
    </el-form>

    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">关闭</el-button>
            <el-button type="primary" @click="save">保存</el-button>
          </span>
    </template>
  </el-drawer>
</template>

<script>
import FormItemRule from "@/components/el/form-item-rule.vue";
import Upload from "@/components/upload/upload.vue";
import TxMap from "@/components/base/tx-map.vue";

export default {
  name: "org-edit-base",
  components: {TxMap, Upload, FormItemRule},
  data() {
    return {
      drawer:false,
      direction:"rtl",
      detail:null,
    }
  },
  mixins: [tableBase],
  methods: {
    openDrawer(){
      this.findDetail();
      this.drawer=true;
    },
    handleClose(){
      this.drawer=false;
    },
    findDetail(){
      this.simpleGet("/api/mgr/business/shop/info/detail",null,result=>{
        let data = result.data;
        this.detail = {id:data.id,storeName:data.storeName,logo:data.logo,address:data.address,storePhone:data.storePhone,longitude:data.longitude,latitude:data.latitude};
      })
    },
    changeAddress(data){
      this.detail.address= data.address;
      this.detail.longitude= data.lng;
      this.detail.latitude= data.lat;
    },
    save(){
      this.simplePost("/api/mgr/business/shop/info/addAudit",this.detail,result=>{
        this.message("保存成功，请耐心等待审核");
        this.$emit("success");
        this.handleClose();
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
